import ih from 'immutability-helper';
import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_ACCOUNTS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: action.payload.accounts,
        },
      };
    case types.GET_ACCOUNTS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.CANCEL_GET_ACCOUNTS:
      return ih(state, { list: { isLoading: { $set: false } } });
    default:
      return state;
  }
};
